module.exports = __webpack_public_path__ + "img/53799ceb4d5ca33da236b022998fe6db.svg";